/**
 * Quick-add button — adds a product to the WC cart via fetch and opens the drawer.
 * Cart open/close is handled by blocks/cart-pill/view.js via window.AriyanCart.
 */

export function initQuickAdd() {
	document.addEventListener( 'click', async ( e ) => {
		const btn = e.target.closest( '[data-quick-add]' );
		if ( ! btn || ! window.AriyanData ) {
			return;
		}

		e.preventDefault();

		const pid = btn.dataset.quickAdd;
		if ( ! pid ) {
			return;
		}

		const originalLabel = btn.textContent;
		btn.textContent = '…';

		try {
			const body = new FormData();
			body.append( 'action', 'woocommerce_add_to_cart' );
			body.append( 'product_id', pid );
			body.append( 'quantity', '1' );

			const res = await fetch( window.AriyanData.ajaxUrl, {
				method: 'POST',
				credentials: 'same-origin',
				body,
			} );

			const json = await res.json();

			// Update cart count from WC fragment.
			const fragmentHtml = json?.fragments?.[ 'span.cart-count' ];
			if ( fragmentHtml ) {
				const tmp = document.createElement( 'div' );
				tmp.innerHTML = fragmentHtml;
				document
					.querySelectorAll( '[data-cart-count]' )
					.forEach( ( el ) => {
						el.textContent =
							tmp.firstElementChild?.textContent ?? '';
					} );
			}

			btn.textContent = window.AriyanData.i18n.addedToCart;
			window.AriyanCart?.open();
		} catch {
			// Silently fail — label restores below.
		} finally {
			setTimeout( () => {
				btn.textContent = originalLabel;
			}, 1400 );
		}
	} );
}
